import { ValueError } from "../Errors/ValueError";
import { colorConfig } from "./ColorConfig";
export class StyleBuilder {
    constructor() {
        this.baseConfig = {};
        //public static getStyleByData(key: string, data: string[]): ChartDataSets {
        //    let foundvalue = this.lookup[key];
        //    for (let i = 0; i < data.length; i++) {
        //        console.log('style loop ' + data[i]);
        //        if (i < 1200) {
        //            foundvalue = this.lookup[key + ' obs'];
        //        }
        //        else {
        //            foundvalue = this.lookup[key + ' fore'];
        //        }
        //        //return foundvalue;
        //    }
        //    //let foundvalue = this.lookup[key];
        //    if (foundvalue === undefined) {
        //        throw new ValueError(`No object found with key: ${key}`)
        //    }
        //    return foundvalue;
        //}
    }
    static getStyle(key) {
        let foundvalue = this.lookup[key];
        if (foundvalue === undefined) {
            throw new ValueError(`No object found with key: ${key}`);
        }
        return foundvalue;
    }
}
StyleBuilder.lookup = {
    "observed inflow": {
        borderColor: "rgb(245, 66, 167)",
        xAxisID: "timeAxis",
        label: "Observed Inflow",
        fill: false,
        backgroundColor: "rgb(245, 66, 167)"
    },
    "harmonie simulated forecast": {
        borderColor: "rgb(191, 63, 151)",
        xAxisID: "timeAxis",
        label: "Harmonie Simulated Forecast",
        fill: false,
        backgroundColor: "rgb(191, 63, 151)",
        hidden: true
    },
    "harmonie simulated historical": {
        borderColor: "rgb(142, 0, 161)",
        xAxisID: "timeAxis",
        label: "Harmonie Simulated Historical",
        fill: false,
        backgroundColor: "rgb(142, 0, 161)",
        hidden: true
    },
    "target flow forecast": {
        borderColor: "rgb(191, 63, 151)",
        xAxisID: "timeAxis",
        label: "Target Flow Forecast",
        fill: false,
        backgroundColor: "rgb(191, 63, 151)",
        pointRadius: 0
    },
    "target flow historical": {
        borderColor: "rgb(191, 0, 151)",
        xAxisID: "timeAxis",
        label: "Target Flow Historical",
        fill: false,
        backgroundColor: "rgb(191, 0, 151)",
        pointRadius: 0
    },
    "harmonie updated forecast": {
        borderColor: "rgb(191, 63, 151)",
        xAxisID: "timeAxis",
        label: "Harmonie Updated Forecast",
        fill: false,
        backgroundColor: "rgb(191, 63, 151)",
        hidden: true
    },
    "harmonie updated historical": {
        borderColor: "rgb(142, 0, 161)",
        xAxisID: "timeAxis",
        label: "Harmonie Updated Historical",
        fill: false,
        backgroundColor: "rgb(142, 0, 161)",
        hidden: true
    },
    "pdfleeug": {
        borderColor: "rgb(0, 0, 0)",
        xAxisID: "timeAxis",
        label: "pdfleeug",
        fill: false,
        backgroundColor: "rgb(0, 0, 0)",
        hidden: true,
        pointRadius: 0
    },
    "observed flow": {
        borderColor: colorConfig["observed flow"],
        xAxisID: "timeAxis",
        label: "Observed Flow",
        fill: false,
        backgroundColor: colorConfig["observed flow"],
        pointStyle: 'rect'
    },
    "historical flow": {
        borderColor: colorConfig["historical flow"],
        xAxisID: "timeAxis",
        label: "Historical Flow",
        fill: false,
        backgroundColor: colorConfig["historical flow"],
    },
    "simulated flow": {
        borderColor: colorConfig["simulated flow"],
        backgroundColor: colorConfig["simulated flow"],
        xAxisID: "timeAxis",
        label: "Simulated Flow",
        fill: false,
        pointRadius: 0,
        pointStyle: 'rect'
    },
    "ovens simulated flow": {
        borderColor: colorConfig["ovens simulated flow"],
        xAxisID: "timeAxis",
        label: "Simulated Flow",
        fill: false,
        backgroundColor: colorConfig["ovens simulated flow"],
        pointRadius: 0
    },
    "inniscarra simulated outflow": {
        borderColor: colorConfig["inniscarra simulated outflow"],
        xAxisID: "timeAxis",
        label: "Simulated Flow",
        fill: false,
        backgroundColor: colorConfig["inniscarra simulated outflow"],
        pointRadius: 0
    },
    "simulated inflow": {
        borderColor: colorConfig["simulated inflow"],
        xAxisID: "timeAxis",
        label: "Simulated Inflow",
        fill: false,
        backgroundColor: colorConfig["simulated inflow"],
        pointRadius: 0
    },
    "observed level": {
        borderColor: 'rgba(4, 74, 0)',
        backgroundColor: 'rgba(4, 74, 0)',
        pointStyle: 'rect',
        xAxisID: "timeAxis",
        label: "Observed Level",
        fill: false,
        type: "line",
        pointRadius: 0
    },
    "simulated water level": {
        borderColor: colorConfig["simulated water level"],
        xAxisID: "timeAxis",
        label: "Simulated Level",
        fill: false,
        backgroundColor: colorConfig["simulated water level"],
        pointStyle: 'rect',
        pointRadius: 0
    },
    "historical water level": {
        borderColor: colorConfig["historical water level"],
        xAxisID: "timeAxis",
        label: "Historical Level",
        fill: false,
        backgroundColor: colorConfig["historical water level"],
        pointStyle: 'rect',
        pointRadius: 0
    },
    "tidal level forecast": {
        borderColor: colorConfig["tidal level forecast"],
        xAxisID: "timeAxis",
        label: "Forecast Tidal Level",
        fill: false,
        backgroundColor: colorConfig["tidal level forecast"],
    },
    "tidal level": {
        borderColor: colorConfig["tidal level"],
        xAxisID: "timeAxis",
        label: "Tidal Level",
        fill: false,
        backgroundColor: colorConfig["tidal level"],
    },
    "tivoli level": {
        borderColor: colorConfig["tivoli level"],
        xAxisID: "timeAxis",
        label: "Tivoli Level",
        fill: false,
        backgroundColor: colorConfig["tivoli level"],
    },
    "precipitation": {
        type: "bar",
        xAxisID: "timeAxis",
        label: "Rainfall",
        borderColor: colorConfig["precipitation"],
        backgroundColor: colorConfig["precipitation"],
    },
    "average precipitation": {
        type: "bar",
        xAxisID: "timeAxis",
        label: "Average Rainfall",
        borderColor: "rgba(67,198,219)",
        backgroundColor: "rgba(67,198,219)",
    },
    "merged precipitation": {
        type: "bar",
        xAxisID: "timeAxis",
        label: "Merged Precipitation",
        borderColor: "rgba(21, 53, 255)",
        backgroundColor: "rgba(21, 53, 255)",
        barThickness: 2
    },
    "ensemble": {
        type: "line",
        xAxisID: "timeAxis",
        fill: false,
        borderColor: undefined,
        backgroundColor: undefined,
    },
    "ecmwf deterministic": {
        type: "bar",
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(67,198,219)",
        backgroundColor: "rgba(67,198,219)",
        barThickness: 2
    },
    "met eireann deterministic": {
        type: "bar",
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(233,53,138)",
        backgroundColor: "rgba(233,53,138)",
        barThickness: 2
    },
    "flow release": {
        borderColor: "rgb(0,255,0)",
        xAxisID: "timeAxis",
        label: "Flow Release",
        fill: false,
        backgroundColor: "rgb(0,255,0)",
    },
    "flow release 48hr": {
        borderColor: "rgb(0,255,0)",
        borderDash: [9, 9],
        borderDashOffset: 5,
        xAxisID: "timeAxis",
        label: "Flow Release 48hr",
        fill: false,
        backgroundColor: "rgb(0,255,0)",
    },
    "flow updated": {
        borderColor: "rgb(0,255,0)",
        borderDash: [9, 9],
        borderDashOffset: 5,
        xAxisID: "timeAxis",
        label: "Flow Release 48hr",
        fill: false,
        backgroundColor: "rgb(0,255,0)",
    },
    "updated blackpool": {
        borderColor: "rgb(0,255,0)",
        borderDash: [9, 9],
        borderDashOffset: 5,
        xAxisID: "timeAxis",
        label: "Updated Flow",
        fill: false,
        backgroundColor: "rgb(0,255,0)",
    },
    "flood predicted": {
        borderColor: "rgb(255, 56, 225)",
        xAxisID: "timeAxis",
        label: "Flood Predicted",
        fill: false,
        backgroundColor: "rgb(255, 56, 225)",
    },
    "max release": {
        borderColor: "rgb(130, 0, 181)",
        xAxisID: "timeAxis",
        label: "Max Release",
        fill: false,
        backgroundColor: "rgb(130, 0, 181)",
    },
    "25th percentile": {
        radius: 0,
        borderColor: colorConfig["25th percentile"],
        xAxisID: "timeAxis",
        //borderDash: [9, 9],
        //borderDashOffset: 5,
        label: "25ᵗʰ Percentile_ensemble",
        fill: false,
        backgroundColor: colorConfig["25th percentile"]
    },
    "75th percentile": {
        radius: 0,
        borderColor: colorConfig["75th percentile"],
        //borderDash: [9, 9],
        //borderDashOffset: 5,
        xAxisID: "timeAxis",
        label: "75ᵗʰ/25ᵗʰ Percentile",
        fill: "25ᵗʰ Percentile_ensemble",
        backgroundColor: colorConfig["75th percentile"],
    },
    "50th percentile": {
        borderColor: "rgb(255, 117, 117)",
        xAxisID: "timeAxis",
        label: "Median",
        fill: false,
        backgroundColor: "rgb(255, 117, 117)",
    },
    "max": {
        radius: 0,
        borderColor: colorConfig["max"],
        xAxisID: "timeAxis",
        label: "Max/ Min",
        fill: "Minimum_ensemble",
        backgroundColor: colorConfig["max"]
    },
    "min": {
        radius: 0,
        borderColor: colorConfig["min"],
        xAxisID: "timeAxis",
        label: "Minimum_ensemble",
        fill: false,
        backgroundColor: colorConfig["min"]
    },
    "merged inflow": {
        borderColor: "rgb(210, 122, 250)",
        xAxisID: "timeAxis",
        label: "Simulated Inflow",
        fill: false,
        backgroundColor: "rgb(210, 122, 250)",
    },
    "choke index": {
        borderColor: colorConfig["choke index"],
        xAxisID: "timeAxis",
        label: "Choke Index",
        fill: false,
        backgroundColor: colorConfig["choke index"],
    },
    "simulated historical": {
        borderColor: colorConfig["simulated historical"],
        xAxisID: "timeAxis",
        label: "Simulated Historical",
        fill: false,
        backgroundColor: colorConfig["simulated historical"],
    },
    "simulated forecast": {
        borderColor: colorConfig["tivoli level"],
        xAxisID: "timeAxis",
        label: "Simulated Forecast",
        fill: false,
        backgroundColor: colorConfig["tivoli level"],
    },
    "updated flow": {
        borderColor: colorConfig["updated flow"],
        xAxisID: "timeAxis",
        label: "Updated flow",
        fill: false,
        backgroundColor: colorConfig["updated flow"],
    },
    "rainfall accumulation": {
        borderColor: colorConfig["rainfall accumulation"],
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        backgroundColor: colorConfig["rainfall accumulation"],
    },
    "ballyvourney": {
        borderColor: "rgb(0,0,255)",
        backgroundColor: "rgb(0,0,255)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "ballyvourney_dashed": {
        borderColor: "rgb(0,0,255)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderDash: [5],
        borderWidth: 2
    },
    "ballingeary": {
        borderColor: "rgb(0,0,155)",
        backgroundColor: "rgb(0,0,155)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "ballingeary_dashed": {
        borderColor: "rgb(0,0,155)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderDash: [5],
        borderWidth: 2
    },
    "bottle hill": {
        borderColor: "rgb(155,0,0)",
        backgroundColor: "rgb(155,0,0)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "bottle hill_dashed": {
        borderColor: "rgb(155,0,0)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderDash: [5],
        borderWidth: 2
    },
    "bweeng": {
        borderColor: "rgb(0,255,0)",
        backgroundColor: "rgb(0,255,0)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "bweeng_dashed": {
        borderColor: "rgb(0,255,0)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderDash: [5],
        borderWidth: 2
    },
    "carrigadrohid": {
        borderColor: "rgb(158,200,100)",
        backgroundColor: "rgb(158,200,100)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "carrigadrohid_dashed": {
        borderColor: "rgb(158,200,100)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderDash: [5],
        borderWidth: 2
    },
    "carriganimma": {
        borderColor: "rgb(0,100,100)",
        backgroundColor: "rgb(0,100,100)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "carriganimma_dashed": {
        borderColor: "rgb(0,100,100)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderDash: [5],
        borderWidth: 2
    },
    "coolea": {
        borderColor: "rgb(225,225,0)",
        backgroundColor: "rgb(225,225,0)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "coolea_dashed": {
        borderColor: "rgb(255,255,0)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderDash: [5],
        borderWidth: 2
    },
    "cork airport": {
        borderColor: "rgb(100,100,0)",
        backgroundColor: "rgb(100,100,0)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "cork airport_dashed": {
        borderColor: "rgb(100,100,0)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderDash: [5],
        borderWidth: 2
    },
    "crookstown": {
        borderColor: "rgb(100,40,100)",
        backgroundColor: "rgb(100,40,100)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "crookstown_dashed": {
        borderColor: "rgb(100,40,100)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderDash: [5],
        borderWidth: 2
    },
    "gearagh": {
        borderColor: "rgb(150,190,240)",
        backgroundColor: "rgb(150,190,240)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "gearagh_dashed": {
        borderColor: "rgb(150,190,240)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderDash: [5],
        borderWidth: 2
    },
    "gougaune": {
        borderColor: "rgb(240,0,240)",
        backgroundColor: "rgb(240,0,240)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "gougaune_dashed": {
        borderColor: "rgb(240,0,240)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        borderWidth: 2,
        fill: false,
        pointRadius: 0,
        borderDash: [5]
    },
    "inniscarra": {
        borderColor: "rgb(40,240,140)",
        backgroundColor: "rgb(40,240,140)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "inniscarra_dashed": {
        borderColor: "rgb(40,240,140)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderDash: [5],
        borderWidth: 2
    },
    "knockarourke": {
        borderColor: "rgb(255,200,150)",
        backgroundColor: "rgb(255,200,150)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "knockarourke_dashed": {
        borderColor: "rgb(255,200,150)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderDash: [5],
        borderWidth: 2
    },
    "mushera": {
        borderColor: "rgb(255,50,100)",
        backgroundColor: "rgb(255,50,100)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "mushera_dashed": {
        borderColor: "rgb(255,50,100)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderDash: [5],
        borderWidth: 2
    },
    "renanairree": {
        borderColor: "rgb(60,160,250)",
        backgroundColor: "rgb(60,160,250)",
        type: 'line',
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderWidth: 2,
        pointStyle: 'rect'
    },
    "renanairree_dashed": {
        borderColor: "rgb(60,160,250)",
        xAxisID: "timeAxis",
        label: "Rainfall accumulation",
        fill: false,
        pointRadius: 0,
        borderDash: [5],
        borderWidth: 2
    },
    "carrig ecmwf": {
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(233,53,138)",
        pointRadius: 0,
        borderWidth: 2,
        backgroundColor: "transparent",
        type: "line",
        pointStyle: "line"
    },
    "carrig me": {
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(233,53,138)",
        pointRadius: 0,
        borderWidth: 3,
        backgroundColor: "transparent",
        type: "line",
        borderDash: [3],
        pointStyle: "dash"
    },
    "cooldaniel ecmwf": {
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(133,53,138)",
        pointRadius: 0,
        borderWidth: 2,
        backgroundColor: "transparent",
        type: "line",
        pointStyle: "line"
    },
    "cooldaniel me": {
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(133,53,138)",
        pointRadius: 0,
        borderWidth: 3,
        backgroundColor: "transparent",
        type: "line",
        borderDash: [3],
        pointStyle: "dash"
    },
    "dripsey ecmwf": {
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(220,153,138)",
        pointRadius: 0,
        borderWidth: 2,
        backgroundColor: "transparent",
        type: "line",
        pointStyle: "line"
    },
    "dripsey me": {
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(220,153,138)",
        pointRadius: 0,
        borderWidth: 3,
        backgroundColor: "transparent",
        type: "line",
        borderDash: [3],
        pointStyle: "dash"
    },
    "innislat ecmwf": {
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(133,253,108)",
        pointRadius: 0,
        borderWidth: 2,
        backgroundColor: "transparent",
        type: "line",
        pointStyle: "line"
    },
    "innislat me": {
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(133,253,108)",
        pointRadius: 0,
        borderWidth: 3,
        backgroundColor: "transparent",
        type: "line",
        borderDash: [3],
        pointStyle: "dash"
    },
    "macroom ecmwf": {
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(233,53,238)",
        pointRadius: 0,
        borderWidth: 2,
        backgroundColor: "transparent",
        type: "line",
        pointStyle: "line"
    },
    "macroom me": {
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(233,53,238)",
        pointRadius: 0,
        borderWidth: 3,
        backgroundColor: "transparent",
        type: "line",
        borderDash: [3],
        pointStyle: "dash"
    },
    "morris's bridge ecmwf": {
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(33,53,138)",
        pointRadius: 0,
        borderWidth: 2,
        backgroundColor: "transparent",
        type: "line",
        pointStyle: "line"
    },
    "morris's bridge me": {
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(33,53,138)",
        pointRadius: 0,
        borderWidth: 3,
        backgroundColor: "transparent",
        type: "line",
        borderDash: [3],
        pointStyle: "dash"
    },
    "bride lat ecmwf": {
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(87,60,240)",
        pointRadius: 0,
        borderWidth: 2,
        backgroundColor: "transparent",
        type: "line",
        pointStyle: "line"
    },
    "bride lat me": {
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(87,60,240)",
        pointRadius: 0,
        borderWidth: 3,
        backgroundColor: "transparent",
        type: "line",
        borderDash: [3],
        pointStyle: "dash"
    },
    "blackpool retail ecmwf": {
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(182,20,20)",
        pointRadius: 0,
        borderWidth: 2,
        backgroundColor: "transparent",
        type: "line",
        pointStyle: "line"
    },
    "blackpool retail me": {
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(182,20,20)",
        pointRadius: 0,
        borderWidth: 3,
        backgroundColor: "transparent",
        type: "line",
        borderDash: [3],
        pointStyle: "dash"
    },
    "carrigrohane bridge ecmwf": {
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(233,53,238)",
        pointRadius: 0,
        borderWidth: 2,
        backgroundColor: "transparent",
        type: "line",
        pointStyle: "line"
    },
    "carrigrohane bridge me": {
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(233,53,238)",
        pointRadius: 0,
        borderWidth: 3,
        backgroundColor: "transparent",
        type: "line",
        borderDash: [3],
        pointStyle: "dash"
    },
    "county hall ecmwf": {
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(210,180,255)",
        pointRadius: 0,
        borderWidth: 2,
        backgroundColor: "transparent",
        type: "line",
        pointStyle: "line"
    },
    "county hall me": {
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(210,180,255)",
        pointRadius: 0,
        borderWidth: 3,
        backgroundColor: "transparent",
        type: "line",
        borderDash: [3],
        pointStyle: "dash"
    },
    "glasheen ecmwf": {
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(120,240,240)",
        pointRadius: 0,
        borderWidth: 2,
        backgroundColor: "transparent",
        type: "line",
        pointStyle: "line"
    },
    "glasheen me": {
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(120,240,240)",
        pointRadius: 0,
        borderWidth: 3,
        backgroundColor: "transparent",
        type: "line",
        borderDash: [3],
        pointStyle: "dash"
    },
    "lee ug lat ecmwf": {
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(100,200,10)",
        pointRadius: 0,
        borderWidth: 2,
        backgroundColor: "transparent",
        type: "line",
        pointStyle: "line"
    },
    "lee ug lat me": {
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(100,200,10)",
        pointRadius: 0,
        borderWidth: 3,
        backgroundColor: "transparent",
        type: "line",
        borderDash: [3],
        pointStyle: "dash"
    },
    "muskerry ecmwf": {
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(45,135,20)",
        pointRadius: 0,
        borderWidth: 2,
        backgroundColor: "transparent",
        type: "line",
        pointStyle: "line"
    },
    "muskerry me": {
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(45,135,20)",
        pointRadius: 0,
        borderWidth: 3,
        backgroundColor: "transparent",
        type: "line",
        borderDash: [3],
        pointStyle: "dash"
    },
    "ovens bridge ecmwf": {
        xAxisID: "timeAxis",
        label: "ECMWF Deterministic Precipitation",
        borderColor: "rgba(140,240,40)",
        pointRadius: 0,
        borderWidth: 2,
        backgroundColor: "transparent",
        type: "line",
        pointStyle: "line"
    },
    "ovens bridge me": {
        label: "Met Eireann Deterministic Precipitation",
        xAxisID: "timeAxis",
        borderColor: "rgba(140,240,40)",
        pointRadius: 0,
        borderWidth: 3,
        backgroundColor: "transparent",
        type: "line",
        borderDash: [3],
        pointStyle: "dash"
    }
};
